class ModalButton extends HTMLElement {
  constructor() {
    super()

    this.addEventListener("click", (event) => {

      // SweetAlert
      // this.modalTitle = this.querySelector('[data-modal-title]')
      // this.modalContent = this.querySelector('[data-modal-content]')

      // if (this.modalTitle !== null) {
      //   this.showModal(this)
      //   return
      // }

      // Native HTMLDialog
      let dialog = this.querySelector('dialog')
      let closeButton = dialog.querySelector('.close-button')

      if (!dialog.open) {
        dialog.showModal()
      } 

      if(event.target === dialog || event.target === closeButton) {
        dialog.close()
      }

    })

  }

  showModal() {
    // console.log(this.modalContent)
    Swal.fire({
      title: this.modalTitle.innerHTML,
      html: this.modalContent.innerHTML,
      showCloseButton: true,
      showConfirmButton: false,
      focusConfirm: false,
      color: '#000000',
      closeButtonHtml: "✕",
      backdrop: 'background: #f00',
      customClass: {
        title: 'text-left font-medium text-lg border-b pb-2 bg-gray-100 rounded-t',
        htmlContainer: '',
        closeButton: 'outline-none'
      },
      showClass: {
        popup: `
          animate__animated
          animate__fadeInUp
          animate__faster
        `
      },
      hideClass: {
        popup: `
          animate__animated
          animate__fadeOutDown
          animate__faster
        `
      }
    })
  }

}

customElements.define('modal-button', ModalButton)